import { PageTitle } from '@procureai/ui-mui';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { UserDomain } from '~/common/types';

export interface UserPageTitleProps {
  domain: UserDomain;
}

export const UserPageTitle = ({ domain }: UserPageTitleProps) => {
  const { t } = useTranslation();

  const title = t(`User.${domain}.title`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitle title={title}></PageTitle>
    </>
  );
};
